import http from '../common/http';
import env from '../envConfig';
import { getHeader, getHeaderRotasAbertas} from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

// TODO Utilizar essa chamada sem a token do gov.br (header), pois deve ser tratada
// como uma rota aberta.
export const obterUFs = async () => {
  const url = env.urlApi + `/transacional-api/v1/sdc/ufs`;
  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

// TODO Utilizar essa chamada sem a token do gov.br (header), pois deve ser tratada
// como uma rota aberta.
export const obterMunicipiosPorUF = async (codigoUfIbge: number) => {
  const url = env.urlApi + `/transacional-api/v1/sdc/municipios/${codigoUfIbge}`;
  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};


export const obterDadosCep = async (cep: any) => {
  const url = env.urlApi + `/transacional-api/v1/sdc/cep/${cep}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
